import React from "react"
import AboutTeamSvg from "./assets/AboutTeamSvg";
import OneTwoBox from "../../bosom/components/layout/boxes/one-two-box/OneTwoBox";

const AboutUs = (props) => {
    const pStyle = {'margin': "0.5rem 0 0 0"};
    const hStyle = {'margin': "1.5rem 0 0 0"};
    return (
        <OneTwoBox svg={<AboutTeamSvg/>}
                   title={"About Us"}
                   description={"We are a passionate and multidisciplinary group of individuals who work together to help individuals and care givers affected by ALS by designing and implementing digital solutions made available anywhere around the globe."}>
            <h3 style={hStyle}>Our Mission</h3>
            <p style={pStyle}>Through science and data, to design, create, and share tools and solutions that increase
                quality of life
                and manageability of the illness for care givers and individuals affected by ALS worldwide.</p>
            <h3 style={hStyle}>Our Motivation</h3>
            <p style={pStyle}>Being personally affect by ALS we understand how difficult life can be for PALS and
                love ones around them. We experienced hopelessness, despair, and the loss of life that unfortunately is
                associated with this illness. As many others before and after us, when we could not find a path forward
                with medical advisors we turned to self directed research and care. Through research, we found hope and
                motivation in various sources citing benefits of specialized therapies on persons with ALS. Among many
                others, the ones bellow inspired us to pursue creation of alsTherapy.io.</p>
            <blockquote style={hStyle} cite={"https://pubmed.ncbi.nlm.nih.gov/30890895/"}>
                Despite the lack of a cure and the rapidly progressive nature of the disease, ALS is considered a
                “treatable disease” and rehabilitation is integral to optimal, comprehensive care. In addition to
                the other health care professions making up the health care team, physical therapy provides a
                critical role in the overall management in individuals with ALS. Physical therapy that is tailored
                to the individual’s needs and goals and focused on addressing symptoms and maximizing function and
                participation enables people with ALS to live their lives to the fullest and with quality.
                <aside>
                    <a href="https://pubmed.ncbi.nlm.nih.gov/30890895/">Bello-Haas VD. Physical therapy for individuals
                        with amyotrophic lateral sclerosis: current insights. Degener Neurol Neuromuscul Dis. 2018 Jul
                        16;8:45-54. doi: 10.2147/DNND.S146949. PMID: 30890895; PMCID: PMC6065609.</a>
                </aside>
            </blockquote>
            <br/><br/>
            <blockquote cite={"https://pubmed.ncbi.nlm.nih.gov/29924018/"}>
                The current results suggest that the positive effect of muscle strengthening exercise is greater at the
                early stage and may be maintained in patients with bulbar type ALS. In addition, improvement can be
                achieved approximately 1 year after onset and in patients with an ALSFRS-R score of 40 points or more.
                Therefore, it is necessary to initiate and continue exercise earlier after onset.
                <aside>
                    <a href="https://pubmed.ncbi.nlm.nih.gov/29924018/">Kato N, Hashida G, Konaka K. Effect of muscle
                        strengthening exercise and time since onset in patients with amyotrophic lateral sclerosis: A
                        2-patient case series study. Medicine (Baltimore). 2018 Jun;97(25):e11145. doi:
                        10.1097/MD.0000000000011145. PMID: 29924018; PMCID: PMC6024467.</a>
                </aside>
            </blockquote>
            <br/><br/>
            <blockquote cite={"https://pubmed.ncbi.nlm.nih.gov/24510737/"}>
                Rehabilitation matters to PALS, because it enables them to reach their fullest potential despite the
                presence of a disabling disease. Further, it is likely that rehabilitation will become even more
                essential when caring for PALS in the near future, as more treatments will hopefully be developed to
                delay disease progression and prolong lifespan.
                <aside>
                    <a href="https://pubmed.ncbi.nlm.nih.gov/24510737/">Majmudar S, Wu J, Paganoni S. Rehabilitation in
                        amyotrophic lateral sclerosis: why it matters. Muscle Nerve. 2014 Jul;50(1):4-13. doi:
                        10.1002/mus.24202. Epub 2014 May 17. PMID: 24510737; PMCID: PMC4433000.</a>
                </aside>
            </blockquote>
            <br/><br/>
            <blockquote
                cite={"https://journals.lww.com/acsm-csmr/fulltext/2015/01000/amyotrophic_lateral_sclerosis__the_role_of.13.aspx"}>
                Exercise has been considered more recently as an intervention to help improve function, slow disease
                progression, and lessen caregiver burden. A number of studies have investigated different types of
                exercise as treatment for ALS.
                <aside>
                    <a href="https://journals.lww.com/acsm-csmr/fulltext/2015/01000/amyotrophic_lateral_sclerosis__the_role_of.13.aspx">Lisle,
                        Stuart MD; Tennison, Matthew MD Amyotrophic Lateral Sclerosis, Current Sports Medicine Reports:
                        January 2015 - Volume 14 - Issue 1 - p 45-46 doi: 10.1249/JSR.0000000000000122</a>
                </aside>
            </blockquote>

            <h3 style={hStyle}>Our Values</h3>
            <ul style={pStyle}>
                <li>We’re in this together. <em>We stay engaged, compassionate, supportive to our users and each
                    other.</em></li>
                <li>Small steps create big wins. <em>We work slow, steady, and focused, we don't sacrifice quality over
                    quantity.</em></li>
                <li>We make decisions based data, never intuition, gut feeling, or personal preferences.</li>
                <li>We focus on long term impact, not short term wins.</li>
                <li>We value well being of our users and ourselves.</li>
            </ul>
        </OneTwoBox>
    )
}

export default AboutUs;
